import React from "react";
import WalletQnaDetail from "../../Components/WalletQna/WalletQnaDetail";
// import LeftMenu from "../../Components/LeftMenu";
import queryString from "query-string";

const WalletQnaDetailPage = ({ match, location }) => {
  const query = queryString.parse(location.search);
  return (
    <React.Fragment>
      {/* <LeftMenu /> */}
      <WalletQnaDetail u_id={query.u_id} />
    </React.Fragment>
  );
};

export default WalletQnaDetailPage;
